"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapServer = exports.bootstrapClient = exports.importAngularRemotes = exports.initializeWebComponent = exports.serverSideMountFactory = exports.clientSideMountFactory = void 0;
var utils_1 = require("../../utils");
var common_mfe_1 = require("../common-mfe");
var main_1 = require("../../main");
var Console_helper_1 = require("../../helpers/Console.helper");
function clientSideMountFactory(DynamicAppModule, AppProps, _a, __mfeName__, roots) {
    var platformBrowserDynamic = _a.platformBrowserDynamic;
    if (roots === void 0) { roots = {}; }
    return function (el, props, options) {
        if (options === void 0) { options = {}; }
        var _a = options.isMounting, isMounting = _a === void 0 ? false : _a;
        var id = props.id;
        if (isMounting && typeof document === "object") {
            var selector = (0, utils_1.getWebComponentMFENameBy)(__mfeName__);
            var child = document.createElement(selector);
            child.setAttribute("data-id", id);
            el.innerHTML = "";
            el.appendChild(child);
            return platformBrowserDynamic()
                .bootstrapModule(DynamicAppModule(new AppProps(props)))
                .then(function (ngModuleRef) {
                roots[id] = ngModuleRef;
                return {};
            });
        }
        else if (id in roots && typeof roots[id].instance === "object") {
            return new Promise(function (resolve, reject) {
                try {
                    var containerRef = roots[id].instance.appRef;
                    containerRef.components.forEach(function (component) {
                        component.instance.setProps(new AppProps(props));
                        component.changeDetectorRef.detectChanges();
                    });
                    resolve({});
                }
                catch (error) {
                    reject(error);
                }
            });
        }
        else {
            return Promise.reject(new Error("[Client Side Mount] Error: Cannot update a not mounted component"));
        }
    };
}
exports.clientSideMountFactory = clientSideMountFactory;
function serverSideMountFactory(AppServerModule, AppProps, _a, __mfeName__) {
    var renderModule = _a.renderModule;
    return function (props) {
        var placeHolderHtml = (0, utils_1.generatePlaceholderHtmlFrom)(__assign(__assign({}, props), { __mfeName__: __mfeName__ }));
        return renderModule(AppServerModule, {
            document: placeHolderHtml,
            url: "/",
            extraProviders: [{ provide: AppProps, useValue: props }],
        })
            .then(function (html) {
            return { html: html };
        })
            .catch(function (err) {
            console.log("serverSideMountFactory err", __mfeName__, err);
            throw new Error(err);
        });
    };
}
exports.serverSideMountFactory = serverSideMountFactory;
function initializeWebComponent(__mfeName__, clientSideMount, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    var selector = (0, utils_1.getWebComponentMFENameBy)(__mfeName__);
    return (0, common_mfe_1.initializeComponent)(selector + "-container", __mfeName__, clientSideMount, childrenRemoteDeps);
}
exports.initializeWebComponent = initializeWebComponent;
function renderMFE(propsBehaviorSubject, remoteDependenciesMap, remote) {
    var mountingMap = Object.keys(remoteDependenciesMap).reduce(function (acc, remoteId) {
        var _a;
        return __assign((_a = {}, _a[remoteId] = true, _a), acc);
    }, {});
    return new Promise(function (resolve, reject) {
        propsBehaviorSubject.asObservable().subscribe(function (props) {
            var allRemotesMounting = Object.entries(remoteDependenciesMap).map(function (_a) {
                var remoteId = _a[0], remoteDependency = _a[1];
                var _b = remoteDependency, elementRef = _b.elementRef, updateProps = _b.updateProps;
                var updatedProps = updateProps(props);
                if (!!updatedProps.id && !!updatedProps.__mfeName__) {
                    if (mountingMap[remoteId]) {
                        Console_helper_1.ConsoleHelper.log(remoteId, "is mounting...");
                    }
                    else {
                        Console_helper_1.ConsoleHelper.log(remoteId, "is updating...");
                    }
                    if (remote) {
                        if (utils_1.BrowserUtils.isClientSide()) {
                            return remote
                                .clientSideMount(elementRef, updatedProps, {
                                isMounting: mountingMap[remoteId],
                            })
                                .then(function () {
                                if (mountingMap[remoteId]) {
                                    Console_helper_1.ConsoleHelper.log(remoteId, "is mounted");
                                    mountingMap[remoteId] = false;
                                }
                                else {
                                    Console_helper_1.ConsoleHelper.log(remoteId, "is updated");
                                }
                                return {};
                            });
                        }
                        else {
                            return remote
                                .serverSideMount(updatedProps)
                                .then(function (_a) {
                                var html = _a.html;
                                if (mountingMap[remoteId]) {
                                    Console_helper_1.ConsoleHelper.log(remoteId, "is mounted");
                                    mountingMap[remoteId] = false;
                                }
                                else {
                                    Console_helper_1.ConsoleHelper.log(remoteId, "is updated");
                                }
                                elementRef.innerHTML = html;
                                return { html: html };
                            });
                        }
                    }
                    else {
                        var html = (0, utils_1.generatePlaceholderHtmlFrom)(updatedProps);
                        elementRef.innerHTML = html;
                        Console_helper_1.ConsoleHelper.log(remoteId, "is mounted with the placeholder", html);
                        return Promise.resolve({ html: html });
                    }
                }
                else {
                    return Promise.resolve({});
                }
            });
            utils_1.PromiseUtils.allSettledFulfilledPromises(allRemotesMounting)
                .then(resolve)
                .catch(reject);
        });
    });
}
function importAngularRemotes(propsBehaviorSubject, allRemoteDependencies) {
    if (allRemoteDependencies === void 0) { allRemoteDependencies = []; }
    var props = propsBehaviorSubject.getValue();
    var importMFE = main_1.CommonMFE.importMFEFactory(props);
    var childrenRemotesDependencies = (0, utils_1.generateChildrenRemotesDependencies)(allRemoteDependencies);
    var result = Object.entries(childrenRemotesDependencies).map(function (_a) {
        var remoteName = _a[0], remoteDependenciesMap = _a[1];
        return importMFE(remoteName).then(function (remote) {
            return renderMFE(propsBehaviorSubject, remoteDependenciesMap, remote);
        });
    });
    return utils_1.PromiseUtils.allSettledFulfilledPromises(result);
}
exports.importAngularRemotes = importAngularRemotes;
function bootstrapClient(DynamicAppModule, AppProps, angularDeps, __mfeName__) {
    var roots = {};
    return {
        __mfeName__: __mfeName__,
        clientSideMount: clientSideMountFactory(DynamicAppModule, AppProps, angularDeps, __mfeName__, roots),
    };
}
exports.bootstrapClient = bootstrapClient;
function bootstrapServer(AppServerModule, AppProps, angularDeps, __mfeName__) {
    return {
        __mfeName__: __mfeName__,
        serverSideMount: serverSideMountFactory(AppServerModule, AppProps, angularDeps, __mfeName__),
    };
}
exports.bootstrapServer = bootstrapServer;
